import { Typography } from "@mui/material";

import { UnknownRights } from "../../../Type";

export default function Market({ exchange }: UnknownRights) {
	return <Typography variant='subtitle2'>{exchange ?? "-"}</Typography>;
}
